<div class="detail-container">
  @if (loading) {
    <div class="state-msg">Cargando pedido…</div>
  } @else if (!order) {
    <div class="state-msg">
      <i class="pi pi-exclamation-triangle" style="font-size: 28px; margin-bottom: 0.5rem; display: block;"></i>
      No se pudo cargar el detalle del pedido.
      <div style="margin-top: 1rem;">
        <p-button label="Volver a pedidos" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (onClick)="goBack()" />
      </div>
    </div>
  } @else {
    <!-- Hero -->
    <div class="hero">
      <div class="hero-left">
        <div class="hero-back">
          <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" styleClass="back-btn" pTooltip="Volver" (onClick)="goBack()" />
          <span class="hero-eyebrow">Pedido</span>
        </div>
        <div class="hero-order">Orden N&deg; {{ formatOrderNumber(order.orderId) }}</div>
        <div class="hero-meta">
          <span class="hero-meta-item"><i class="pi pi-calendar"></i> Creado: {{ order.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          <span class="hero-meta-item"><i class="pi pi-flag-fill"></i> Entregado: {{ orderDeliveredAt ? (orderDeliveredAt | date: 'dd/MM/yyyy HH:mm') : 'Pendiente' }}</span>
        </div>
      </div>
      <p-tag
        [value]="getStatusConfig(order.statusId)?.name ?? order.statusName"
        [style]="{ 'background-color': getStatusConfig(order.statusId)?.color }"
        styleClass="hero-status-tag"
      ></p-tag>
    </div>

    <!-- Stepper de progreso (solo cuando el pedido sigue su recorrido normal) -->
    @if (!isTerminalStatus) {
      <div class="card stepper-card">
        <div class="stepper">
          @for (step of progressSteps; track step.statusId; let i = $index) {
            <div
              class="step"
              [class.step-done]="i < currentStepIndex || (isDelivered && i === currentStepIndex)"
              [class.step-current]="i === currentStepIndex && !isDelivered"
              [style.--step-color]="step.color"
            >
              <div class="step-dot">
                @if (i < currentStepIndex || (isDelivered && i === currentStepIndex)) {
                  <i class="pi pi-check"></i>
                }
              </div>
              <span class="step-label">{{ step.name }}</span>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="card terminal-banner" [style.--step-color]="getStatusConfig(order.statusId)?.color">
        <i class="pi pi-info-circle"></i>
        Este pedido terminó en estado <strong>{{ getStatusConfig(order.statusId)?.name ?? order.statusName }}</strong>.
      </div>
    }

    <!-- Cliente / Entrega -->
    <div class="cards-grid">
      <div class="card">
        <h3>Cliente</h3>
        <p><span>Nombre</span> <strong>{{ order.customer.name }} {{ order.customer.lastName }}</strong></p>
        <p><span>Teléfono</span> <strong>{{ order.customer.phone }}</strong></p>
        <p><span>Email</span> <strong>{{ order.customer.email }}</strong></p>
      </div>
      <div class="card">
        <h3>Entrega</h3>
        <p><span>Dirección</span> <strong>{{ order.deliveryAddress }}</strong></p>
        @if (order.notes) {
          <p><span>Notas</span> <strong>{{ order.notes }}</strong></p>
        }
      </div>
    </div>

    <!-- Productos -->
    <div class="card products-card">
      <h3>Productos</h3>
      <p-table [value]="order.items" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 72px;"></th>
            <th>Producto</th>
            <th style="width: 90px; text-align: center;">Cant.</th>
            <th style="width: 120px; text-align: right;">Precio unit.</th>
            <th style="width: 120px; text-align: right;">Subtotal</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <img
                *ngIf="item.pro_image_url; else noProductImage"
                class="product-thumb"
                [src]="item.pro_image_url"
                [alt]="item.productName"
                loading="lazy"
                (error)="item.pro_image_url = ''"
              />
              <ng-template #noProductImage>
                <span class="product-thumb product-thumb--empty"><i class="pi pi-image"></i></span>
              </ng-template>
            </td>
            <td>{{ item.productName }}</td>
            <td style="text-align: center;">{{ item.quantity }}</td>
            <td style="text-align: right;">{{ item.unitPrice | currency }}</td>
            <td style="text-align: right;">{{ item.subtotal | currency }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="totals">
        <div class="totals-row"><span>Subtotal</span><span>{{ order.subtotal | currency }}</span></div>
        <div class="totals-row"><span>Envío</span><span>{{ order.deliveryFee | currency }}</span></div>
        <div class="totals-row totals-total"><span>Total</span><span>{{ order.total | currency }}</span></div>
      </div>
    </div>

    <!-- Repartidor / viaje de entrega -->
    <div class="card">
      <h3>Repartidor y entrega</h3>

      @if (!order.deliveryTrip) {
        <div class="empty-state">
          <i class="pi pi-truck"></i>
          Aún no se ha asignado un repartidor a este pedido.
        </div>
      } @else {
        <div class="trip-info">
          <p>
            <span>Estado del viaje</span>
            <p-tag
              [value]="formatStatusName(order.deliveryTrip.statusName)"
              [style]="{ 'background-color': getTripStatusColor(order.deliveryTrip.statusName) }"
              styleClass="trip-status-tag"
            ></p-tag>
          </p>
          <p><span>Asignado</span> <strong>{{ order.deliveryTrip.assignedAt ? (order.deliveryTrip.assignedAt | date: 'dd/MM/yyyy HH:mm') : 'Pendiente' }}</strong></p>
          <p><span>Recogido</span> <strong>{{ order.deliveryTrip.pickedUpAt ? (order.deliveryTrip.pickedUpAt | date: 'dd/MM/yyyy HH:mm') : 'Pendiente' }}</strong></p>
          <p><span>Entregado</span> <strong>{{ order.deliveryTrip.deliveredAt ? (order.deliveryTrip.deliveredAt | date: 'dd/MM/yyyy HH:mm') : 'Pendiente' }}</strong></p>
          @if (order.deliveryTrip.driverNotes) {
            <p><span>Nota del repartidor</span> <strong>{{ order.deliveryTrip.driverNotes }}</strong></p>
          }
        </div>

        @if (!order.deliveryTrip.driver) {
          <div class="empty-state">
            <i class="pi pi-user"></i>
            Repartidor aún no asignado.
          </div>
        } @else {
          <div class="driver-head">
            <div class="avatar-ring">
              <img
                [src]="order.deliveryTrip.driver.photo"
                alt="Foto del repartidor"
                class="avatar-img"
                (error)="onDriverPhotoError($event)"
              />
            </div>
            <div class="driver-info">
              <span class="driver-name">{{ order.deliveryTrip.driver.name }} {{ order.deliveryTrip.driver.lastName }}</span>
              <span class="driver-phone"><i class="pi pi-phone"></i> {{ order.deliveryTrip.driver.phone }}</span>
              <span class="driver-score"><i class="pi pi-star-fill"></i> {{ order.deliveryTrip.driver.score }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
